import * as React from "react";
import { SelectEditor } from "../../../../react-core/Html/SelectEditor";
import { ModelPortfolioTabType } from "../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { ProductType } from "../../../../Wrap/Constants/Enums/Domain/ProductType";
import { InstrumentSearchQuery } from "../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { RestrictionStore } from "../../../Dashboard/Components/Clients/Common/Restrictions/Variable";
import { InvestmentSelectionAction } from "../Action/InvestmentSelectionAction";
import { ISearchProps } from "../Resource/Content";
import { AutoComplete } from "./Shared/AutoComplete";

export const AdviserPortfolios = (props: ISearchProps) => {
    const query: InstrumentSearchQuery = {
        CanBeBought: true,
        ProductTypes: [ProductType.AdviserModelPortfolio],
        ProductWrapperTypes: [props.type],
    };
    const [adviserPortfolios, setAdviserPortfolios] = React.useState([]);
    React.useEffect(() => {
        InvestmentSelectionAction.searchInstruments(query, props.hiercharyId, (data) => {
            setAdviserPortfolios(data);
        });
    }, []);
    return (
        <div>
            {/* <AutoComplete
                placeholder="Select adviser portfolio"
                label="Search"
                query={query}
                hiercharyId={props.hiercharyId}
                onSelected={(investment) => {
                    InvestmentSelectionAction.addInvestment(
                        investment,
                        ModelPortfolioTabType.AdviserModel,
                        props.hiercharyId,
                        true
                    );
                }}
                minLengh={0}
                disabled={RestrictionStore.buyDisabled()}
                onLookupError={() => {}}
                cssWrapper="label-sr-only submit-is-magnifier-glass mb-0"
            /> */}
            <SelectEditor
                label={"Adviser portfolios"}
                selected={null}
                placeholder={"Select adviser portfolio"}
                options={adviserPortfolios.sort((a, b) => {
                    return a?.Name?.toLowerCase() > b?.Name?.toLowerCase() ? 1 : -1;
                })}
                getText={(o) => {
                    return o.Name;
                }}
                onChange={(investment) => {
                    InvestmentSelectionAction.addInvestment(
                        investment,
                        ModelPortfolioTabType.AdviserModel,
                        props.hiercharyId,
                        true
                    );
                }}
            />
        </div>
    );
};
